import React from "react";
import styles from "./TaskBoardCard.module.scss";
import clsx from "clsx";
import moment from "moment";
import Avatar from "@/components/UI/Avatar/Avatar";

interface User {
  id: string;
  name: string;
  avatarUrl?: string;
}

interface TaskBoardCardProps {
  title: string;
  status: "pendiente" | "enprogreso" | "completado";
  startDate?: string;
  endDate?: string;
  users?: User[];
  onClick?: () => void;
}

const statusLabels: Record<string, string> = {
  pendiente: "Pendiente",
  enprogreso: "En Progreso",
  completado: "Completado",
};

export const TaskBoardCard: React.FC<TaskBoardCardProps> = ({
  title,
  status,
  startDate,
  endDate,
  users = [],
  onClick,
}) => {
  return (
    <div
      className={clsx(
        styles.taskCard,
        styles[`taskCard--${status}`]
      )}
      onClick={onClick}
    >
      <div className={styles.statusLabel}>{statusLabels[status]}</div>

      <div className={styles.title} title={title}>
        {title}
      </div>

      <div className={styles.footer}>
        <div className={styles.avatars}>
          {users.map(user => (
            <div key={user.id} className={styles.avatarWrapper}>
              <Avatar
                src={user.avatarUrl}
                name={user.name}
                size="sm"
              />
              <div className={styles.tooltip}>{user.name}</div>
            </div>
          ))}
        </div>

        <div className={styles.dates}>
          {startDate && endDate ? (
            <>
              {moment(startDate).format("MMM D")} - {moment(endDate).format("MMM D")}
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
}; 